import React from "react";

export default function Shelter() {
  return (
    <div className="shelter" id="nftstaking">
      <div className="container-fluid">
        <div id="content">
          <h1>HomerDoges shelter</h1>
        </div>

        <div className="row">
          <div className="col-md-6 bg-blue text-center">
            <img src="./Asserts/card.png" className="img-fluid" alt="" />
          </div>
          <div className="col-md-6 bg-yellow text-center">
            <img src="./Asserts/tree.png" className="img-fluid" alt="" />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div id="paragraph">
              <p>
                <span>NFT Staking Platform</span> <br /> we are going to develop
                a way to stake and breed your HomerDoge NFT’s there will be 3333
                mintable HomerDoge NFT with all different DNA aspect you can
                breed them into new NFT’s and these can all be traded on our
                HomerDoge Shelter giving you passive income during this meme
                season !
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
